<div class="relative h-72 overflow-hidden gradient-primary-header">
    <div class="absolute inset-0 bg-black/40"></div>
    <div
        class="absolute inset-0 opacity-20"
        style="background-image: url('https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1600'); background-size: cover; background-position: center center;">
    </div>
</div>

<section class="surface-elevated mb-8 p-6 sm:p-8">
    <div class="flex flex-col items-start gap-8 lg:flex-row">
        <div class="flex w-full flex-col items-center text-center lg:w-auto lg:text-start">
            <div class="relative mb-4">
                @if (expert.image) {
                    <img [src]="expert.image" [alt]="expert.name" class="h-32 w-32 rounded-xl border border-border-strong object-cover shadow-elevated">
                } @else {
                    <div class="flex h-32 w-32 items-center justify-center rounded-xl border border-border-primary bg-primary-soft text-4xl font-bold text-primary shadow-elevated">
                        {{ getInitials() }}
                    </div>
                }
                @if (expert.isVerified) {
                    <div class="absolute -bottom-2 flex h-10 w-10 items-center justify-center rounded-full border border-success/20 bg-success-soft text-success shadow-subtle ltr:-right-2 rtl:-left-2">
                        <i class="fas fa-circle-check text-lg"></i>
                    </div>
                }
            </div>
            <div class="mb-4 flex flex-wrap justify-center gap-2">
                <span class="badge badge-primary gap-1">
                    <i class="fas fa-trophy text-[10px]"></i>
                    {{ 'experts.profile.featured' | translate }}
                </span>
                @if (expert.isVerified) {
                    <span class="badge badge-success gap-1">
                        <i class="fas fa-circle-check text-[10px]"></i>
                        {{ 'experts.profile.verified' | translate }}
                    </span>
                }
            </div>
        </div>

        <div class="flex-1">
            <div class="mb-5">
                <h1 class="h2 mb-2" dir="auto">{{ expert.name }}</h1>
                <p class="body-large mb-3">{{ ('experts.types.' + expert.expertType) | translate }}</p>
                <div class="mb-4 flex flex-wrap items-center gap-4 text-sm text-text-secondary">
                    <div class="flex items-center gap-1.5">
                        <i class="fas fa-star text-sm text-warning"></i>
                        <span class="font-bold text-text-primary">{{ expert.rating }}</span>
                        <span class="text-xs text-text-muted">({{ expert.reviewsCount }} {{ 'experts.card.review' | translate }})</span>
                    </div>
                    <div class="flex items-center gap-1.5">
                        <i class="fas fa-location-dot text-text-muted"></i>
                        @if (expert.location.startsWith('experts.')) {
                            {{ expert.location | translate }}
                        } @else {
                            {{ expert.location }}
                        }
                    </div>
                    <div class="flex items-center gap-1.5">
                        <i class="fas fa-briefcase text-text-muted"></i>
                        {{ expert.experienceYears }} {{ 'experts.card.yearsExperience' | translate }}
                    </div>
                </div>
                <div class="mb-4 flex flex-wrap gap-2">
                    @for (tag of expert.tags; track tag) {
                        <span class="badge badge-primary">{{ tag }}</span>
                    } @empty {
                        <span class="badge badge-neutral">{{ 'experts.profile.defaultTagResidential' | translate }}</span>
                        <span class="badge badge-neutral">{{ 'experts.profile.defaultTagHomes' | translate }}</span>
                    }
                </div>
            </div>
            <div class="flex flex-wrap gap-3">
                <button class="btn btn-primary">
                    <i class="fas fa-phone text-xs"></i>
                    {{ 'experts.profile.callNow' | translate }}
                </button>
                <button class="btn btn-secondary">
                    <i class="fas fa-message text-xs"></i>
                    {{ 'experts.profile.sendMessage' | translate }}
                </button>
                <button class="btn-icon border border-border-strong" [attr.aria-label]="'experts.profile.share' | translate">
                    <i class="fas fa-share-nodes text-xs"></i>
                </button>
            </div>
        </div>
    </div>

    <div class="mt-8 grid grid-cols-2 gap-3 border-t border-border-subtle pt-8 md:grid-cols-4 lg:grid-cols-8">
        <div class="profile-stat">
            <i class="fas fa-circle-check"></i>
            <div class="profile-stat__value">{{ expert.dealsCount }}</div>
            <div class="profile-stat__label">{{ (expert.type === 'developer' ? 'experts.profile.completedProjects' : 'experts.profile.successfulDeals') | translate }}</div>
        </div>
        <div class="profile-stat">
            <i class="fas fa-building"></i>
            <div class="profile-stat__value">{{ expert.propertiesCount }}</div>
            <div class="profile-stat__label">{{ (expert.type === 'developer' ? 'experts.profile.availableUnits' : 'experts.profile.availableProperties') | translate }}</div>
        </div>
        @if (expert.responseTimeLabel && expert.type !== 'developer') {
        <div class="profile-stat">
            <i class="fas fa-clock"></i>
                            <div class="profile-stat__value" dir="auto">{{ expert.responseTimeLabel }}</div>
            <div class="profile-stat__label">{{ 'experts.profile.responseTime' | translate }}</div>
        </div>
        }
        <div class="profile-stat">
            <i class="fas fa-award"></i>
            <div class="profile-stat__value">{{ expert.experienceYears }}</div>
            <div class="profile-stat__label">{{ 'experts.profile.yearsExperience' | translate }}</div>
        </div>
    </div>
</section>
